export const TrafficCone = () => {
    return (
        <svg fill="currentColor" aria-hidden="true" viewBox="0 0 65 63">
            <path
                d="M9.828 57.19H3.186a2.571 2.571 0 0 0-.121 5.141l.12.003h58.858a2.572 2.572 0 0 0 .12-5.14l-.12-.003H55.4L35.878 3.092c-1.103-3.056-5.425-3.056-6.528 0z"
                opacity=".5"
            />
            <path d="m42.513 21.477 5.361 14.857h-30.52l5.362-14.858zm-27.014 20H49.73l5.671 15.714H9.828zm25.158-25.143L35.84 2.984c-1.09-3.02-5.36-3.02-6.45 0l-4.818 13.35z" />
        </svg>
    );
};
